import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, canonical, image }) => {
  const siteTitle = "Metro Midas";
  const fullTitle = `${title} | ${siteTitle}`;
  const defaultDescription = "Professional IT services including cloud solutions, managed IT, and cybersecurity";
  const siteUrl = "https://metromidas.com";
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {canonical && <link rel="canonical" href={`${siteUrl}${canonical}`} />}
      
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:url" content={`${siteUrl}${canonical}`} />
      {image && <meta property="og:image" content={`${siteUrl}${image}`} />}
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {image && <meta name="twitter:image" content={`${siteUrl}${image}`} />}
    </Helmet>
  );
};

export default SEO;